import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";

export class FrameContainer extends Phaser.GameObjects.Container {

    private stripe1Array: Phaser.GameObjects.Image[];
    private stripe2Array: Phaser.GameObjects.Image[];
    private f1: number;
    private f2: number;

    constructor(scene: Phaser.Scene, side: string) {
        
        super(scene);

        this.y = GameConstants.GAME_HEIGHT / 2 - 365 * GameVars.scaleY;
        this.scaleY = GameVars.scaleY;

        if (side === "right") {
            this.x = GameConstants.GAME_WIDTH;
            this.scaleX = -1;
        }

        let numFrames: number;
        let numGems: number;

        if (GameVars.isDesktop) {
            numFrames = 10;
            numGems = 24;
        } else {
            const aspectRatio = window.innerHeight / window.innerWidth;
            numFrames = Math.ceil(aspectRatio * 5 + 3.5);
            numGems = Math.ceil(aspectRatio * 10 + 11);
        }

        for (let i = 0; i < numFrames; i ++) {
            const frame = new Phaser.GameObjects.Image(this.scene, 0, 88 * i, "texture_atlas_2", "side_column");
            frame.setOrigin(0);
            this.add(frame);
        }

        this.stripe1Array = [];
        this.stripe2Array = [];

        for (let i = 0; i < numGems; i ++) {

            const x = 26;
            const y = 38 * i;
            const n = i % 5;
            const gem = new Phaser.GameObjects.Image(this.scene, x, y, "texture_atlas_1", "gem_0" + (n + 1).toString());
            gem.setScale(.5);
            this.add(gem);

            this.stripe1Array.push(gem);
        }

        for (let i = 0; i < numGems; i ++) {

            const x = 63;
            const y = 38 * i + 19;
            const n = (i + 3) % 5;
            const gem = new Phaser.GameObjects.Image(this.scene, x, y, "texture_atlas_1", "gem_0" + (n + 1).toString());
            gem.setScale(.5);
            this.add(gem);

            this.stripe2Array.push(gem);
        }

        this.f1 = 0;
        this.f2 = this.stripe2Array.length;

        const transparentLayer = new Phaser.GameObjects.Graphics(this.scene);
        transparentLayer.fillStyle(0x0A2A4C, .5);
        transparentLayer.fillRect(0, 0, 86, GameConstants.GAME_HEIGHT / GameVars.scaleY);
        this.add(transparentLayer);

        const upperAlphaGradient = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_2", "side_column_gradient");
        upperAlphaGradient.setOrigin(1);
        upperAlphaGradient.alpha = .85;
        upperAlphaGradient.angle = 180;
        this.add(upperAlphaGradient);

        const lowerAlphaGradient = new Phaser.GameObjects.Image(this.scene, 0, (GameConstants.GAME_HEIGHT - this.y) / GameVars.scaleY, "texture_atlas_2", "side_column_gradient");
        lowerAlphaGradient.setOrigin(0, 1);
        lowerAlphaGradient.alpha = .85;
        this.add(lowerAlphaGradient);
    }

    public update(): void {

        this.f1 += .2;
        this.f2 -= .2;

        if (this.f1 >= this.stripe1Array.length) { 
            this.f1 = 0;
        }

        if (this.f2 <= 0) { 
            this.f2 = this.stripe2Array.length;
        }

        for (let i = 0; i < this.stripe1Array.length; i ++) {

            const gem = this.stripe1Array[i];
            
            let s = gem.scaleX;

            if (Math.floor(this.f1) === i || Math.floor(this.f1) === i + 6) {
                s *= 1.03;
            } else {

                s *= .995;

                if (s < .5) {
                    s = .5;
                }
            }
            
            gem.setScale(s);
        }

        for (let i = 0; i < this.stripe2Array.length; i ++) {

            const gem = this.stripe2Array[i];
            
            let s: number = gem.scaleX;

            if (Math.floor(this.f2) === i || Math.floor(this.f1) === i + 6) {
                s *= 1.01375;
            } else {

                s *= .995;

                if (s < .5) {
                    s = .5;
                }
            }
            
            gem.setScale(s);
        }
    }
}
